const main = {
  state: {
    refs: {},
    allCategoriesShown: false,
    childrenView: false,
    categoriesView: false,
    companyView: false,
    map: null,
  },
  mutations: {
    setRef(state, v) {
      state.refs[v.name] = v.value;
    },
    setAllCategoriesShown(state, v) {
      state.allCategoriesShown = v;
    },
    setChildrenView(state, v) {
      state.childrenView = v;
    },
    setCategoriesView(state, v) {
      state.categoriesView = v;
    },
    setCompanyView(state, v) {
      state.companyView = v;
    },
    setMap(state, v) {
      state.map = v;
    },
    setMetaTitle(state, v) {
      document.title = v + " - Bestprice.be";
    },
    setH1(state, v) {
      document.querySelector("h1.catalog__heading_h1").innerText = v;
    },
    triggerDynamicH1Resize() {
      $(".catalog__heading").trigger("resize");
    },
  },
  actions: {},
  getters: {
    getCategoriesCol(state) {
      return state.cols.categories;
    },
    getCategoryChildrenCol(state) {
      return state.cols.category_children;
    },
    getChildrenView(state) {
      return state.childrenView;
    },
    getCategoriesView(state) {
      return state.categoriesView;
    },
    getCompanyView(state) {
      return state.companyView;
    },
    getAllCategoriesShown(state) {
      return state.allCategoriesShown;
    },
    getMap(state) {
      return state.map;
    },
  },
};

export default main;
